// The most basic fetcher available. Returns the JSON of the response stream,
// and gives no details on errors (undefined in this case.)

import { buildRequestAndFetch } from '../fetcher-core';
import { getJsonOrUndefined } from '../response';
import { maybeHandleCustomError } from '../util';

async function requestApi<T>(
  path: string,
  method = 'GET',
  bodyContent: any | undefined = undefined,
): Promise<T | undefined> {
  try {
    const response = await buildRequestAndFetch(path, method, bodyContent);
    const parsed = await getJsonOrUndefined<T>(response);
    if (!response.ok) {
      await maybeHandleCustomError(parsed);
      return undefined;
    }
    return parsed;
  } catch (e) {
    return undefined;
  }
}

export async function getFromApi<T>(path: string): Promise<T | undefined> {
  return await requestApi<T>(path, 'GET');
}

export async function postToApi<R>(path: string, body = {}): Promise<R | undefined> {
  return await requestApi<R>(path, 'POST', body);
}

export async function deleteFromApi<R>(path: string, body = {}): Promise<R | undefined> {
  return await requestApi<R>(path, 'DELETE', body);
}
